/**
 * Author: Andrey Morozov
 * Confidential. Proprietary code. Do not distribute without authorization.
 *
 * presenceSlice.ts — presenc\1 \2lice (services/operator-web-app).
 */

import type { PresenceStatus } from '@/realtime/types';

export interface PresenceState {
  status: PresenceStatus;
  registeredAt: string | null;
  heartbeatIntervalMs: number;
  presenceTtlMs: number;
  pauseReason: string | null;
  lastEventId: string | null;
}

export const initialPresenceState: PresenceState = {
  status: 'offline',
  registeredAt: null,
  heartbeatIntervalMs: 15_000,
  presenceTtlMs: 45_000,
  pauseReason: null,
  lastEventId: null,
};

export function reducePresence(
  state: PresenceState,
  eventType: string,
  payload: Record<string, unknown>,
  eventId: string
): PresenceState {
  switch (eventType) {
    case 'presence_snapshot': {
      const p = payload as {
        status: PresenceStatus;
        registered_at: string;
        heartbeat_interval_ms: number;
        presence_ttl_ms: number;
        pause_reason?: string;
      };
      return {
        ...state,
        status: p.status,
        registeredAt: p.registered_at ?? null,
        heartbeatIntervalMs: p.heartbeat_interval_ms ?? state.heartbeatIntervalMs,
        presenceTtlMs: p.presence_ttl_ms ?? state.presenceTtlMs,
        pauseReason: p.pause_reason ?? null,
        lastEventId: eventId,
      };
    }
    case 'presence_status_changed': {
      const p = payload as { from: PresenceStatus; to: PresenceStatus; reason?: string };
      return {
        ...state,
        status: p.to,
        pauseReason: p.reason ?? null,
        lastEventId: eventId,
      };
    }
    default:
      return state;
  }
}
